module.exports = __webpack_public_path__ + "assets/6b0c0a85d69fe0de333200ae63eb35f1.png";